import { URL } from '@/config/url';
import Watermark from '@/shared/assets/article-image-overlay.svg?svg';
import { EntityListArticleItem } from '@/shared/api/__generated__/models';
import * as ArticleComponents from '@/shared/ui/Article';
import { formatArticleDate } from '@/shared/utils';
import Image from 'next/image';
import Link from 'next/link';

import styles from './MainArticle.module.css';

interface MainArticleProps {
  article: EntityListArticleItem;
  rubricName: string;
}

export const MainArticle = ({ article, rubricName }: MainArticleProps) => {
  const { cover_url, publish_date, title, short_description, id, slug } =
    article;

  return (
    <Link className={styles.root} href={URL.article(slug ?? id ?? '')}>
      <ArticleComponents.ArticleDate
        fontSize={12}
        fontWeight={500}
        lineHeight="100%"
        color="black"
      >
        {formatArticleDate(publish_date ?? '')}{' '}
        {rubricName ? `· ${rubricName}` : ''}
      </ArticleComponents.ArticleDate>
      <div
        className={styles.imageWrapper}
        style={
          {
            '--background-image': `url(${cover_url ?? ''})`,
          } as React.CSSProperties
        }
      >
        <Image
          className={styles.image}
          src={cover_url ?? ''}
          alt={title ?? ''}
          width={280}
          height={163}
          loading="lazy"
        />
        <Watermark className={styles.imageOverlay} />
      </div>
      <div className={styles.content}>
        <ArticleComponents.ArticleTitle
          as="p"
          className={styles.title}
          fontSize={18}
          fontWeight={800}
          letterSpacing={-0.198}
          lineHeight={24}
        >
          {title}
        </ArticleComponents.ArticleTitle>
        <ArticleComponents.ArticleDescription
          className={styles.description}
          as="p"
          fontSize={14}
          lineHeight="160%"
          fontWeight={400}
        >
          {short_description}
        </ArticleComponents.ArticleDescription>
      </div>
    </Link>
  );
};
